<template>
  <div>
    <Modal
      v-model="openWindow"
      title="选择需要上传的文件"
      :draggable="false"
      footer-hide
      width="400"
    >
      <div class="pic_question" id="vm">
        <input
          @change="fileChange($event)"
          type="file"
          ref="upload_file123"
          style="display: none"
          multiple
        />
        <h2 style="font-size: 18px">未下载模板</h2>
        <p style="font-size: 14px">
          导入必须用指定模板，还没模板可点击这里<Button
            type="text"
            @click="downLoad"
            >下载模板</Button
          >
        </p>
        <h2 style="margin-top: 20px; font-size: 18px">已下载模板</h2>

        <span style="font-size: 14px; margin-right: 10px">
          {{ file.name }} </span
        ><Button @click="open" type="primary" ghost size="small">{{
          file.name == "未选择任何文件" ? "选择文件" : "重新选择"
        }}</Button>
        <Row type="flex" justify="end">
          <Col span="24">
            <div class="btn-wrap">
              <Button @click="clickCancel123">取消</Button>
              <Button type="primary" @click="daoru">提交</Button>
            </div>
          </Col>
        </Row>
      </div>
    </Modal>
    <Modal
      v-model="openDaoruYichang"
      :title="msg.message"
      :mask-closable="false"
      footer-hide
      width="400"
    >
      <ly-form-item label="错误行">{{ msg.row }}</ly-form-item>
      <ly-form-item label="错误列">{{ msg.column }}</ly-form-item>
      <ly-form-item label="错误值">{{ msg.data }}</ly-form-item>
    </Modal>
  </div>
</template>
<script>
import axios from "axios";
export default {
  data() {
    return {
      temUrl: "",
      url: "",

      file: {
        name: "未选择任何文件",
      },
      openWindow: false,
      template: "",
      openDaoruYichang: false,
      msg: {
        row: 0,
        column: 0,
        data: "",
      },
      yichangData: [],
      failTitle: "",
    };
  },
  methods: {
    reach(v) {
      this.temUrl = v.temUrl;
      this.url = v.url;
      this.openWindow = true;
    },
    open() {
      this.$refs.upload_file123.click();
    },
    fileChange(v) {
      var d = this.$refs.upload_file123.files[0];
      this.template = d;
      this.file.name = d.name;
    },
    downLoad() {
      console.log(this.temUrl);
      this.utils.downLoad(this.temUrl);
    },
    clickCancel123() {
      this.openWindow = false;
      // document.getElementById("upload_file123").reset();
    },
    daoru() {
      if (this.template.length == 0) {
        this.$Message.error({
          content: "请先选择文件",
          duration: 2,
        });
        return;
      }

      let params = new window.FormData();
      params.append("template", this.template);
      this.utils.loading(this, "导入中");
      axios({
        method: "post",
        url: this.url,
        data: params,
      }).then((res) => {
        this.$Spin.hide(); //关闭加载
        console.log(res);
        if (res.data.code == 200) {
          this.$emit("finesh");
          this.openWindow = false;
        } else {
          this.msg = res.data.data;
          this.openDaoruYichang = true;
        }
        return;
        if (res.data.code != 200) {
          this.$Message.error(res.data.message);
        } else {
          this.clickCancel123();
          this.yichangData = res.data.data.failItemList;
          this.$Message.success({
            content: "成功导入" + res.data.data.success + "条数据",
            duration: 2,
          });
          if (this.yichangData.length > 0) {
            this.openDaoruYichang = true;
            this.failTitle = "导入异常数据(" + res.data.data.fail + ")";
          }
        }
      });
    },
  },
};
</script>
<style>
/* 拍照 上传图片--------------------------------- */
.pic_question {
  padding: 0 0.48rem;
}

.add-image {
  float: left;
  width: 60px;
  height: 60px;
  font-size: 60px;
  color: #868686;
  position: relative;
  border: 1px solid #7a7a7a;
  text-align: center;
  line-height: 2.8rem;
  font-weight: lighter;
}

.img-list {
  flex-wrap: wrap;
  float: left;
}

.img-list > li {
  width: 60px;
  height: 60px;
  position: relative;
  margin-right: 10px;
  margin-bottom: 10px;
  display: inline-block;
}
.img-list > li .del {
  position: absolute;
  top: -8px;
  right: -4px;
  color: #2c2c2c;
  width: 20px;
  height: 20px;
  border-radius: 50%;
  opacity: 0.5;
  font-size: 24px;
}
.img-list > li > img {
  width: 100%;
  height: 100%;
}
</style>


// WEBPACK FOOTER //
// src/components/common/daoru.vue